import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header text-base font-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Variants options")
], -1)
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "px-3" }
const _hoisted_4 = { class: "px-3" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "capitalize tex-xl font-bold" }, " Your product variants ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "capitalize tex-xl font-bold" }, "Product stock", -1)
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_slot_error = _resolveComponent("slot-error")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "Map stocks",
      width: "70%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = false)),
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSubmit())),
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "mapStockForm",
          model: _ctx.formData.product,
          rules: _ctx.formRules,
          "label-width": "120px",
          class: "demo-ruleForm"
        }, {
          default: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 0,
                  gutter: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_skeleton, {
                          rows: 12,
                          animated: true
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_card, null, {
              header: _withCtx(() => [
                _hoisted_1
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 12,
                      class: "p-3 justify-center flex items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_el_image, {
                              style: {"width":"100px","height":"auto"},
                              src: _ctx.formData.product.mockup,
                              "preview-src-list": [_ctx.formData.product.mockup],
                              "initial-index": 1
                            }, {
                              error: _withCtx(() => [
                                _createVNode(_component_slot_error)
                              ]),
                              _: 1
                            }, 8, ["src", "preview-src-list"])
                          ]),
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formData.product.title), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.formData.product.variants.length) + " variants", 1)
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 12,
                      class: "p-3 items-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          clearable: "",
                          modelValue: _ctx.formData.product.mappedProductId,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.product.mappedProductId) = $event)),
                          placeholder: "Select warehouse product",
                          class: "mx-2",
                          filterable: "",
                          "fit-input-width": "true",
                          style: {"display":"block"},
                          onChange: _ctx.onChangeProduct
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.refProduct, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item._id,
                                placeholder: "Warehouse product",
                                label: item.title,
                                value: item._id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { class: "my-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.product.variants, (ov, iov) => {
                  return (_openBlock(), _createBlock(_component_el_row, {
                    class: "my-2",
                    key: iov
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox, {
                            onChange: _ctx.onChangeOption,
                            label: ov.title,
                            modelValue: ov.checked,
                            "onUpdate:modelValue": ($event: any) => ((ov.checked) = $event)
                          }, null, 8, ["onChange", "label", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.onChangeOption,
                            modelValue: ov.optionSet,
                            "onUpdate:modelValue": ($event: any) => ((ov.optionSet) = $event),
                            placeholder: `Select`
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.variants, (cc) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: cc,
                                  label: cc.title,
                                  value: cc._id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}